

















































































import { ValidationProvider } from "vee-validate";
import { Component, Vue, Prop, Emit, Watch, Ref } from "vue-property-decorator";

@Component({
  components: {
    ValidationProvider,
  },
})
export default class FormCheckbox extends Vue {
  @Prop() name?: string;

  @Prop() value!: boolean | string[];

  @Prop() placeholder?: string;

  @Prop() rules?: string | object;

  @Prop() label?: string;

  @Prop({ default: true }) showError?: boolean;

  @Prop({ default: false }) disabled!: boolean;

  @Prop({ default: "text" }) type!: string;

  @Prop({ default: "text-14" }) labelClass!: string;

  @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;

  localValue: boolean | string[] = false;

  trueValue = true;

  falseValue = false;

  private get formValdiated(): boolean {
    return this.provider.$_veeObserver?.flags?.validated;
  }

  private get validateAs(): string {
    if (this.label) {
      return this.label;
    }

    if (this.placeholder) {
      return this.placeholder;
    }

    if (this.name) {
      return this.name;
    }

    return `checkbox field`;
  }

  get isChecked() {
    if (this.localValue instanceof Array && typeof this.value === "string") {
      return this.localValue.includes(this.value);
    }

    return this.localValue === this.trueValue;
  }

  @Emit("input")
  private handleInput(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    let isChecked = checkbox.checked;

    if (this.localValue instanceof Array && typeof this.value === "string") {
      let newValue = [...this.localValue];
      if (isChecked) {
        newValue.push(this.value);
      } else {
        newValue.splice(newValue.indexOf(this.value), 1);
      }
      return newValue;
    } else {
      return isChecked ? this.trueValue : this.falseValue;
    }
  }

  @Watch("value", { immediate: true })
  private valueChanged(newValue: boolean | string[]) {
    this.localValue = newValue;
  }
}
